import styles from "./interview.module.scss";

export const NoInterviewForm = () => {
  return (
    <div className={styles.no_int_form_container}>
      <div className={styles.text_container}>No Interview forms available.</div>
    </div>
  );
};
